import { deleteRequest, getRequest, putRequest } from "../utils/api";

export const getDevices = async (siteId) => {
  const response = await getRequest(`/Device/${siteId}`);
  return response;
};

/------ New Get Devices API ------ /;

export const getDevicesNew = async () => {
  const response = await getRequest(`/Device/GetDevices`);
  return response;
};

export const getDevicesStatus = async (deviceId) => {
  const response = await getRequest(`/Device/status/${deviceId}`);
  return response;
};

export const getSystemStatus = async (systemId) => {
  const response = await getRequest(`/Device/devicestatus/${systemId}`);
  return response;
};

export const deleteParameter = async (parameterId) => {
  const response = await deleteRequest(`/Device/status/${parameterId}`);
  return response;
};

export const updateDeviceParamter = async (parameterInfo) => {
  const response = await putRequest(`/Device/status`, parameterInfo);
  return response;
};

/------ Alert Notification API ------ /;

export const getAlertSummary = async (systemId) => {
  const response = await getRequest(
    `/Dashboard/alertsnotification/${systemId}`,
  );
  return response;
};

export const getAlarmSummaryNew = async () => {
  const response = await getRequest(`/Map/ErrorNotifications/`);
  return response;
};

export const assignWorkOrderStatus = async (alertId) => {
  const response = await putRequest(
    `/Map/AssignWorkOrderStatusFromAlert?alertId=${alertId}`,
  );
  return response;
};
